<div class="min-h-screen flex">
  <div class="hidden lg:flex lg:w-1/2 sticky top-0 h-screen shrink-0 relative flex-col justify-between p-10 bg-cover bg-center"
    style="background-image: url('assets/images/bg/receipt-bg.jpg')">
    <div class="absolute inset-0 bg-slate-900/40"></div>
    <div class="relative z-10">
      @if (detail()?.companyLogoUrl) {
        <img [src]="detail()!.companyLogoUrl" alt="Logo" class="h-16 w-auto max-w-[220px] object-contain" />
      } @else {
        <img src="assets/images/pento-icon.png" alt="Pento" class="h-8 w-auto" />
      }
    </div>
    <p class="relative z-10 text-white text-2xl font-semibold">Pagos seguros,<br />simples y rápidos.</p>
  </div>

  <div class="w-full lg:w-1/2 h-screen overflow-y-auto bg-slate-100">
    <div class="min-h-full flex flex-col justify-center px-5 py-8 sm:px-10 max-w-lg w-full mx-auto">
      @if (loading()) {
        <div class="bg-white rounded-2xl shadow-xl border border-slate-200 p-10 text-center">
          <p class="text-slate-400 text-sm">Cargando recibo...</p>
        </div>
      } @else if (error() || !detail()) {
        <div class="bg-white rounded-2xl shadow-xl border border-slate-200 p-10 text-center">
          <p class="text-slate-700 font-medium">No se pudo cargar el recibo</p>
        </div>
      } @else {
        @let receipt = detail()!;
        <div class="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden">
          @if (receipt.status === 'PAID') {
            <div class="bg-emerald-600 px-6 py-5 flex items-center gap-4">
              <div class="flex items-center justify-center w-11 h-11 rounded-full bg-white/20 shrink-0">
                <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path>
                </svg>
              </div>
              <div>
                <p class="text-white font-bold text-base leading-tight">Pago recibido</p>
                <p class="text-emerald-100 text-xs mt-0.5">Esta liga ya fue pagada</p>
              </div>
            </div>
          } @else if (receipt.status === 'EXPIRED') {
            <div class="bg-slate-500 px-6 py-8 text-center">
              <div class="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white/20 mb-3">
                <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
                  </path>
                </svg>
              </div>
              <p class="text-white font-bold text-lg">Liga de pago expirada</p>
              <p class="text-slate-200 text-sm mt-1">Este recibo ya no está disponible para pago</p>
            </div>
          } @else if (receipt.status === 'CANCELLED') {
            <div class="bg-slate-500 px-6 py-8 text-center">
              <div class="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white/20 mb-3">
                <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M6 18L18 6M6 6l12 12">
                  </path>
                </svg>
              </div>
              <p class="text-white font-bold text-lg">Liga de pago cancelada</p>
              <p class="text-slate-200 text-sm mt-1">Este recibo ya no está disponible para pago</p>
            </div>
          } @else {
            <div
              class="px-6 py-5 flex items-center gap-4"
              [class.bg-amber-500]="!isOverdue(receipt)"
              [class.bg-red-600]="isOverdue(receipt)">
              <div class="flex items-center justify-center w-11 h-11 rounded-full bg-white/20 shrink-0">
                <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
                  </path>
                </svg>
              </div>
              <div>
                <p class="text-white font-bold text-base leading-tight">Recibo pendiente de pago</p>
                <p
                  class="text-xs mt-0.5"
                  [class.text-amber-100]="!isOverdue(receipt)"
                  [class.text-red-100]="isOverdue(receipt)">
                  @if (isOverdue(receipt)) {
                    La fecha de vencimiento del pago ha pasado.
                  } @else {
                    Esta liga aún no ha sido pagada
                  }
                </p>
              </div>
            </div>
          }
          <div class="px-6 py-5 border-b border-slate-100">
            <p class="text-[10px] uppercase tracking-widest text-slate-400">Liga de pago</p>
            <p class="font-mono font-semibold text-slate-800">{{ receipt.number || '—' }}</p>
            <p class="text-sm text-slate-500 mt-1">{{ receipt.customerName || receipt.companyName }}</p>
          </div>
          <div class="px-6 py-5 space-y-3">
            @for (line of receipt.lines ?? []; track $index) {
              <div class="flex justify-between text-sm gap-3">
                <span class="min-w-0">{{ line.name }} × {{ line.quantity }}</span>
                <span class="shrink-0">{{ formatAmount(line.subtotal, receipt.currencyCode) }}</span>
              </div>
            } @empty {
              <div class="flex justify-between text-sm">
                <span>{{ receipt.concept }} × {{ receipt.quantity }}</span>
                <span>{{ formatAmount(receipt.subtotal, receipt.currencyCode) }}</span>
              </div>
            }
            <div class="flex justify-between text-sm text-slate-500">
              <span>Impuestos</span>
              <span>{{ formatAmount(receipt.tax, receipt.currencyCode) }}</span>
            </div>
            <div class="flex justify-between font-semibold text-slate-900 border-t border-dashed pt-3">
              <span>Total</span>
              <span>{{ formatAmount(receipt.total, receipt.currencyCode) }}</span>
            </div>
            <p class="text-xs text-slate-400">
              {{ receipt.expiresAt ? ('Vigente hasta ' + (receipt.expiresAt | date:'dd/MM/yyyy HH:mm')) : 'Sin fecha de vencimiento' }}
            </p>
            @if (hasNotes(receipt.notes)) {
              <div class="border-t border-slate-100 pt-3">
                <p class="text-[10px] uppercase tracking-widest text-slate-400 mb-2">Notas</p>
                <div
                  class="max-w-full overflow-x-auto break-words text-sm text-slate-700 [overflow-wrap:anywhere] [&_p]:mb-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_img]:h-auto [&_img]:max-w-full [&_table]:w-full"
                  [innerHTML]="receipt.notes">
                </div>
              </div>
            }
          </div>
          @if (canPay(receipt)) {
            <div class="px-6 pb-6">
              <button type="button"
                class="flex items-center justify-center gap-2 w-full py-3 px-4 rounded-xl bg-slate-800 hover:bg-slate-700 active:bg-slate-900 text-white text-sm font-bold transition-colors shadow-md disabled:opacity-80"
                [disabled]="paying()" (click)="pay(receipt)">
                @if (paying()) {
                  <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Preparando pago...
                } @else {
                  <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z">
                    </path>
                  </svg>
                  Pagar ahora
                }
              </button>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
